//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQTreeConfigBody from "@/components/Generics/TreeConfiguration/AQTreeConfigBody.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";

export default {
    name: "ViewAQTreeConfigBody",
    components: {
        AQInput,
        AQButton,
        AQTreeConfigBody,
        AQModal
    },
    data() {
        return {
            applicationId: null,
            dataItem: null,
            parsedDataItem: null,
            setDataForLoad: null,
            parsedDataForLoad: null,
            aqTreeConfigBodyModal: false
        };
    },
    beforeDestroy() {
        this.$store.commit("main/setCurrentApplicationId", "");
    },
    methods: {
        modalAction(evt) {
            console.log(evt);
            if (evt === "close") {
                this.aqTreeConfigBodyModal = false;
            }
        },
        valueChanged() {
            this.parsedDataItem = this.dataItem ? JSON.parse(this.dataItem) : {};
            this.parsedDataForLoad = this.setDataForLoad ? JSON.parse(this.setDataForLoad) : {};
            this.$store.commit("main/setCurrentApplicationId", this.applicationId);
            this.aqTreeConfigBodyModal = true;
        },
        resetValues() {
            this.dataItem = null;
            this.setDataForLoad = null;
        }
    }
};

